import { useSelector, useDispatch } from 'react-redux';
import { Box, Flex, Text, Card, Badge, Button } from '@radix-ui/themes';
import UserAvatar from '../common/UserAvatar';
import { Link } from 'react-router-dom';
import GuardianStudentOverviewSkeleton from '../skeletons/GuardianStudentOverviewSkeleton';
import GuardianAddWard from '../../screens/guardian/GuardianAddWard';
import { updateUser } from '../../redux/slices/userSlice';
import { updateAccount } from '../../redux/slices/accountSlice';
import { updateStudentAccount } from '../../redux/slices/studentAccountSlice'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api';

const GuardianStudentOverview = ({ reports }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  
  const handleSwitchAccount = async (student) => {
    try {
      //Logging in with student id
      const response = await api.post(`/login-with-student-id/${student.id}`);
      const loginData = response.data;

      localStorage.setItem('guardianUserId', user.details.id);
      localStorage.setItem('authToken', loginData.user.authToken);

      dispatch(updateUser(loginData.user));
      dispatch(updateAccount(loginData.account));
      dispatch(updateStudentAccount(loginData.account))

      navigate('/student');
    } catch (error) {
      console.log('Error switching to student account:', error);
      toast.error("Couldn't switch to student account. Please try again.", {
        position: "bottom-right"
      });
    }
  };

  return (
    <Flex direction="column" gap="3">
      {reports.map((report) => {
        const totalQuizzes = report.quizzes.length;
        const quizzesTaken = report.quizzes.filter(quiz => quiz.attempts.length > 0).length;
        const quizzesMissed = totalQuizzes - quizzesTaken;

        const allAttempts = report.quizzes.flatMap(quiz => quiz.attempts);

        // Calculate averages for all scores
        const averagePercentage = allAttempts.length > 0
          ? allAttempts.reduce((sum, attempt) => sum + attempt.percentage, 0) / allAttempts.length
          : 0;

        const averageVocabulary = allAttempts.length > 0
          ? allAttempts.reduce((sum, attempt) => sum + attempt.vocabulary_score, 0) / allAttempts.length
          : 0;

        const averageConcept = allAttempts.length > 0
          ? allAttempts.reduce((sum, attempt) => sum + attempt.concept_score, 0) / allAttempts.length
          : 0;

        const averageApplication = allAttempts.length > 0
          ? allAttempts.reduce((sum, attempt) => sum + attempt.application_score, 0) / allAttempts.length
          : 0;

        return (
          <div key={report.student.id} style={{ textDecoration: 'none' }}>
            <Card>
              <Flex align="center" gap="3" p="3" justify="between">
                <Flex direction="row" justify="start" align="center" gap="3"
                  className='cursor-pointer'
                  onClick={() => navigate(`/guardian/students/${report.student.id}`)}
                >
                  <UserAvatar user={report.student} size="6" />
                  <Flex direction="column" justify="start" align="start" gap="1">
                    <Text size="3" weight="bold">
                      {report.student.firstname} {report.student.lastname}
                    </Text>
                    <Text size="2" color="gray">
                      {report.student.school || 'School not specified'}
                    </Text>
                    <Flex gap="2">
                      <Badge color="gray">{quizzesTaken} Taken</Badge>
                      {quizzesMissed > 0 && (
                        <Badge color="red">{quizzesMissed} Missed</Badge>
                      )}
                    </Flex>
                    {allAttempts.length > 0 && (
                      <Flex gap="2" wrap="wrap">
                        <Badge color={averagePercentage >= 70 ? 'green' : 'orange'}>
                          Overall: {isNaN(averagePercentage) ? '0' : averagePercentage.toFixed(1)}%
                        </Badge>
                        <Badge color={averageVocabulary >= 70 ? 'green' : 'orange'}>
                          Vocab: {isNaN(averageVocabulary) ? '0' : averageVocabulary.toFixed(1)}%
                        </Badge>
                        <Badge color={averageConcept >= 70 ? 'green' : 'orange'}>
                          Concept: {isNaN(averageConcept) ? '0' : averageConcept.toFixed(1)}%
                        </Badge>
                        <Badge color={averageApplication >= 70 ? 'green' : 'orange'}>
                          Apply: {isNaN(averageApplication) ? '0' : averageApplication.toFixed(1)}%
                        </Badge>
                      </Flex>
                    )}
                  </Flex>
                </Flex>

                <Button color="grass" variant="soft" size={1} className='cursor-pointer w-[63px] text-[11px]' onClick={() => handleSwitchAccount(report.student)} >
                  Switch
                </Button>

              </Flex>
            </Card>
          </div>
        );
      })}
      {/* <GuardianAddWard /> */}
    </Flex>
  );
};

export default GuardianStudentOverview;
